module.exports = __webpack_public_path__ + "static/biker-2.inline-latest-b628a371257c5a5175d94aad633df2ac.svg";